import React from "react"
import { routePaths } from "../.."
import { AppAuthCheck } from "../../../Components/Common/AuthCheck/AppAuthCheck"
import { AppWorkerList } from "../../../Components/Views/Dashboard/Sections/AppDetail/Worker/AppWorkerList"
import { defaultAppWorkerSort } from "../../../Components/Views/Dashboard/Sections/AppDetail/Worker/Common/constants"
import { useDecodeFilterAndSort } from "../../../Hooks/useDecodeFilterAndSort"
import { AppDetailRouteComponentProps } from "../../RouteProps"

export function AppWorkerListRoute({
    match,
    location
}: AppDetailRouteComponentProps<{}>) {
    const { sort } = useDecodeFilterAndSort(
        location.search,
        defaultAppWorkerSort,
        routePaths.appWorkerList(match.params.orgUsername, match.params.appID)
    )

    return (
        <AppAuthCheck {...match.params} scope="workers:view">
            <AppWorkerList {...match.params} sort={sort} />
        </AppAuthCheck>
    )
}
